module.exports = __webpack_public_path__ + "img/inbox.0c5b05f2.svg";